import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { colors } from '@guryou/colors';
import { PricingModel } from '@guryou/core';
import { DefaultText, Form, Spinner } from '@guryou/html-components';
import { getPublicSessions, stateIsNotReady } from '@guryou/redux';
import { printDate, printPrice, printTime } from '@guryou/utils';
import { WidgetContext } from './WidgetContext';

const WidgetClassSessions = ({ gyClass }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const sessions = gyClass.sessions;
  const { selectedSessions, setSessionActiveStep, setSelectedSessions, setSelsectedOfferForCourse, fontF, fontS } = useContext(WidgetContext);
  const [isSelectAllChecked, setIsSelectAllChecked] = useState(gyClass.model === PricingModel.total);

  useEffect(() => {
    dispatch(getPublicSessions(gyClass.id));
  }, [dispatch, gyClass.id]);

  if (stateIsNotReady(sessions)) {
    return <Spinner />;
  }

  if (!sessions.length) {
    return <DefaultText>{t('SESSIONS.noSessionsInClass')}</DefaultText>;
  }

  const selectedUniqueSessions = (id, checked) => {
    if (checked) {
      setSelectedSessions([...selectedSessions, id]);
    } else {
      setSelectedSessions(selectedSessions.filter(x => x !== id));
    }
  };

  const onSubmit = data => {
    if (!data.sessions) {
      return;
    }

    if (gyClass.model === PricingModel.total) {
      setSessionActiveStep(s => s + 1);
      setSelectedSessions(sessions.map(x => +x.id));
      setSelsectedOfferForCourse(sessions[0].classId);
      return;
    }
    const sessionsArray = Array.isArray(data.sessions) ? data.sessions : [data.sessions];
    if (!sessionsArray.length) {
      return;
    }
    setSessionActiveStep(s => s + 1);
    setSelectedSessions(sessionsArray.map(x => +x));
    setSelsectedOfferForCourse(sessions[0].classId);
  };

  return (
    <div>
      <Form actions={false} parserVersion={2} onSubmit={onSubmit}>
        <div class="relative overflow-x-auto shadow-md max-h-[400px]">
          <table class="w-full text-sm text-left rtl:text-right text-gray-500">
            <thead class={`text-xs text-white uppercase bg-[${colors.mandy}]`}>
              <tr>
                <th scope="col" class="p-4">
                  <div class="flex items-center">
                    <input
                      type="checkbox"
                      class={`w-4 h-4 text-[${colors.mandy}] bg-gray-100 border-gray-300 rounded focus:ring-[${colors.mandy}] focus:ring-2`}
                      disabled={gyClass.model === PricingModel.total}
                      checked={isSelectAllChecked}
                      onChange={checked => {
                        setIsSelectAllChecked(checked.target.checked);
                      }}
                    />
                    <label for="checkbox-all-search" class="sr-only">
                      checkbox
                    </label>
                  </div>
                </th>
                <th scope="col" class="px-6 py-3">
                  {`${t('GENERAL.allSessions')} ${gyClass.model === PricingModel.total ? printPrice(gyClass.price) : ''}`}
                </th>
                <th scope="col" class="px-6 py-3">
                  {t('SERVICES.startTime')}
                </th>
                {gyClass.model !== PricingModel.total && (
                  <th scope="col" class="px-6 py-3">
                    {t('GENERAL.price')}
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {sessions.map(x => {
                return (
                  <tr class="bg-white border-b hover:bg-gray-50">
                    <td class="w-4 p-4">
                      <div class="flex items-center">
                        <input
                          type="checkbox"
                          class={`w-4 h-4 text-[${colors.mandy}] bg-gray-100 border-gray-300 rounded focus:ring-[${colors.mandy}] focus:ring-2`}
                          key={`${x.id}_${isSelectAllChecked || selectedSessions?.includes(+x.id)}`}
                          disabled={gyClass.model === PricingModel.total}
                          name="sessions"
                          value={x.id}
                          sx={{ fontFamily: fontF }}
                          checked={isSelectAllChecked || selectedSessions?.includes(x.id)}
                          id="checkbox1"
                          onChange={e => selectedUniqueSessions(x.id, e.target.checked)}
                        />
                        <label for="checkbox-table-search-1" class="sr-only">
                          checkbox
                        </label>
                      </div>
                    </td>
                    <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap ">
                      {printDate(x.startTime)}
                    </th>
                    <td class="px-6 py-4">
                      {printTime(x.startTime)} - {printTime(x.endTime)}
                    </td>
                    {gyClass.model !== PricingModel.total && <td class="px-6 py-4">{printPrice(x.price)}</td>}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div class="flex justify-end mt-6">
          <button
            type="submit"
            style={{ backgroundColor: colors.mandy }}
            class="max-w-[160px] text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-200 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-red-100 font-medium rounded-lg text-sm px-5 py-2.5 inline-flex justify-center w-full text-center"
          >
            {t('VIDEO_COURSE_PAGE.next')}
          </button>
        </div>
      </Form>
    </div>
  );
};

export default WidgetClassSessions;
